exports.PartnerLocation = [
    {
      id: "id",
      name: "id",
      type: "number",
      value: "",
      label: "Id",
      key: "true",
    },
    {
      id: "keys",
      name: "keys",
      type: "text",
      value: "",
      label: "keys",
      length: 50,
    },
    {
        id: "partnerId",
        name: "partnerId",
        type: "text",
        value: "",
        label: "Partner Id",
        length: 20,
      },
      {
        id: "locationId",
        name: "locationId",
        type: "text",
        value: "",
        label: "Location Id",
      },
    {
      id: "createdBy",
      name: "createdBy",
      type: "text",
      label: "Created By",
      displayonly: "true",
      value: " ",
    },
    {
      id: "createdOn",
      name: "createdOn",
      type: "datetime",
      label: "Created On",
      displayonly: "true",
      value: " ",
    },
    {
      id: "modifiedBy",
      name: "modifiedBy",
      type: "text",
      label: "Modified By",
      displayonly: "true",
      value: " ",
    },
    {
      id: "modifiedOn",
      name: "modifiedOn",
      type: "datetime",
      label: "ModifiedOn",
      displayonly: "true",
      value: " ",
    },
  ];
  